import { Route as OriginalRoute } from "react-router-dom";
import { withSentryRouting } from "@sentry/react";

export const Route = withSentryRouting(OriginalRoute);
